import * as React from 'react';
import { connect } from "react-redux";
import { Dispatch } from "redux";
import bindAllOfThis from "src/utils/BindThisHelper";
import removeEmptyProperties from 'src/utils/RemoveBlankProperties';
import { ConfigState } from "src/redux/ConfigReducer";
import { ReduxStoreModel } from "src/redux/ReduxModel";

interface PhaserGameComponentProps {
    /**
     * Config for the game. You should atleast provide a better name and a version
     *
     *    Example
     *    {
     *      title: "Awesome Game",
     *      version: "1.0.0"
     *    }
     */
    config?: GameConfig;
    /**
     * The scenes to render, either single object or array
     *
     * This is moved outside of the config to ensure that they are passed to the game
     */
    scenes: typeof Phaser.Scene | typeof Phaser.Scene[];
    onComplete?: () => void;

    // From Redux
    Config: ConfigState;
}

interface PhaserGameComponentState {
    fooStyle: React.CSSProperties;
}

const defaultConfig: GameConfig = {
    title: "Generic Phaser Game",
    version: "0.0.1-Pre Alpha",
    width: 1360,
    height: 768,
    type: Phaser.AUTO,
    parent: "phaser-game-parent",
    input: {
        keyboard: true,
        mouse: true,
        touch: true,
        gamepad: true
    },
    backgroundColor: "#000000",
    "render.pixelArt": true,
};

class PhaserGameComponent extends React.Component<PhaserGameComponentProps, PhaserGameComponentState> {
    protected game: Phaser.Game = null;
    protected config: GameConfig = null;

    constructor(props: PhaserGameComponentProps) {
        super(props);
        bindAllOfThis(this, PhaserGameComponent.prototype);

        this.state = {
            fooStyle: {}
        };
    }

    componentDidMount() {
        if (this.game == null) {
            this.config = { ...defaultConfig, ...this.props.config, ...{ scene: this.props.scenes } };

            if (!this.props.Config.audioEnabled) {
                console.warn("Audio is disabled"); // JB - Remove this console.warn
                this.config = { ...this.config, audio: { noAudio: true } };
            }

            this.game = new Phaser.Game(this.config);
            (this.game as any).onComplete = this.props.onComplete;
        }

        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        this.game.destroy(true);
        this.game = null;
    }

    updateDimensions() {
        const PADDING_OFFSET: number = 0;
        const HEADER_OFFSET: number = 100;
        const FOOTER_OFFSET: number = 32; // More of a button offset
        let cool = this.calculateAspectRatioFit(1360, 768, window.innerWidth - (PADDING_OFFSET * 2), window.innerHeight - PADDING_OFFSET - FOOTER_OFFSET - HEADER_OFFSET);
        this.setState({
            fooStyle: { ...cool }
        } as PhaserGameComponentState);
    }
    calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return { width: srcWidth * ratio, height: srcHeight * ratio };
    }

    render() {
        return <div id="phaser-game-parent" style={this.state.fooStyle} />;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        Config: state.Config,
    };
}

export default connect(mapStateToProps)(PhaserGameComponent);



// WEBPACK FOOTER //
// ./src/games/shared/phaserHelpers/PhaserGameComponent.tsx